module.exports = __webpack_public_path__ + "img/SearchIconGrey.a1f5a006.svg";